import RoomWallArtwork from './RoomWallArtwork';

export default RoomWallArtwork;
